module.exports = __webpack_public_path__ + "static/media/ribbon-banner-svgrepo-com.27c295e9.svg";